import type { Voice } from './types';

export type HeroTheme = 'memory' | 'family' | 'sea' | 'events' | 'daily' | 'request' | 'critical';
export interface CuratedHeroStory {
  id: string;
  source: Voice['source'];
  theme: HeroTheme;
  text: string;
  gender: string;
  age: string;
  frequency: string;
}

/** The editorial selection is fixed; text is always resolved from sanitized voices.json. */
export const CURATED_HERO_REGISTRY = [
  ['2391', 'atc_episode', 'memory'], ['1575', 'atc_image', 'family'], ['1810', 'atc_episode', 'daily'], ['2357', 'atc_episode', 'events'],
  ['2375', 'atc_episode', 'family'], ['2129', 'comments', 'sea'], ['2022', 'atc_episode', 'events'], ['1988', 'atc_episode', 'memory'],
  ['1908', 'atc_image', 'events'], ['1841', 'atc_image', 'sea'], ['1750', 'comments', 'request'], ['1731', 'comments', 'request'],
  ['1606', 'atc_image', 'critical'], ['1577', 'atc_image', 'sea'], ['1566', 'atc_image', 'family'], ['1548', 'comments', 'request'],
  ['1247', 'atc_image', 'family'], ['1223', 'comments', 'critical'],
] as const satisfies readonly [string, Voice['source'], HeroTheme][];

function invariant(condition: unknown, message: string): asserts condition { if (!condition) throw new Error(`curated heroes: ${message}`); }

export function curateHeroStories(voices: readonly Voice[]): CuratedHeroStory[] {
  invariant(CURATED_HERO_REGISTRY.length === 18, 'exactly 18 records are required');
  const result = CURATED_HERO_REGISTRY.map(([id, source, theme]) => {
    const voice = voices.find((item) => item.id === id && item.source === source);
    invariant(voice, `${id}/${source} is missing from sanitized voices.json`);
    invariant(!/(^|\D)\d{7}(\D|$)/.test(voice.text), `${id} contains a seven-digit postal code`);
    return { id, source, theme, text: voice.text, gender: voice.gender, age: voice.age, frequency: voice.frequency };
  });
  invariant(new Set(result.map((item) => `${item.id}:${item.source}`)).size === 18, 'records must be unique');
  return result;
}
